import { useAtomValue } from 'jotai'
import { useResetAtom } from 'jotai/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ExecuteCancelDialog,
  type ExecuteCancelDialogProps,
} from '~/components/elements/ExecuteCancelDialog'

import { dialogInfoAtom } from '../atoms'
import { useInvalidateArchivedDocumentReportsInfiniteQuery } from '../hooks/useArchivedDocumentReportsInfiniteQuery'
import { useUpdateDocumentReportStatusMutation } from '../hooks/useUpdateDocumentReportStatusMutation'

export const DeleteDocumentReportDialog = () => {
  const { t } = useTranslation()
  const dialogInfo = useAtomValue(dialogInfoAtom)
  if (dialogInfo?.dialogType !== 'delete') {
    throw new Error()
  }
  const { documentReport } = dialogInfo

  const resetDialogInfo = useResetAtom(dialogInfoAtom)
  const invalidateArchivedDocumentReportsInfiniteQuery =
    useInvalidateArchivedDocumentReportsInfiniteQuery()
  const updateDocumentReportStatusMutation =
    useUpdateDocumentReportStatusMutation({
      onSuccess: () => {
        invalidateArchivedDocumentReportsInfiniteQuery()
        resetDialogInfo()
      },
    })
  const handleExecute = React.useCallback<
    EH<ExecuteCancelDialogProps, 'onExecute'>
  >(() => {
    updateDocumentReportStatusMutation.mutate({
      documentReportId: documentReport.id,
      newStatus: 'removed',
    })
  }, [documentReport.id, updateDocumentReportStatusMutation])

  return (
    <ExecuteCancelDialog
      executing={updateDocumentReportStatusMutation.isPending}
      mode="delete"
      title={t('permanently_delete_document')}
      onCancel={resetDialogInfo}
      onExecute={handleExecute}
    >
      {t('delete_completely_confirmation', { target: documentReport.title })}
    </ExecuteCancelDialog>
  )
}
